import { TextWidgetV2 } from "@ecologi/react-components/src/TextWidgetV2";
import { useRouter } from "next/router";

export default function TextWidgetV2Wrapper(props) {
  const router = useRouter();
  return <TextWidgetV2 {...props.data} slug={router?.query?.slug} />;
}
